export const DEFAULT_IMG_URL =
  'https://res.cloudinary.com/ds6dxgvxo/image/upload/v1599441549/q0w2ucvdunr0ta8gu5ti.png'

export const CLOUDINARY_ENDPOINT =
  'https://api.cloudinary.com/v1_1/ds6dxgvxo/image/upload'

export const PROFILE_IMG_PLACEHOLDER =
"https://immedilet-invest.com/wp-content/uploads/2016/01/user-placeholder.jpg"
